import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'yesNo',
})
export class YesNoPipe implements PipeTransform {

    transform(value: any, strict = true, yes = 'Yes', no = 'No', none = ''): string {
        if (Array.isArray(value)) {
            return value.length > 0 ? yes : no;
        }
        if (typeof value === 'string') {
            return value.trim() !== '' ? yes : no;
        }
        if (strict && (value === null || typeof value === 'undefined')) {
            return none;
        }
        return value ? yes : no;
    }
}
